import getEventBusInstance, { BaseEventBus } from './event-bus';

const implementations = {
  global: getEventBusInstance({ debug: false, logPrefix: 'IntranetBus' }),
  // place all others instance you want
};

export class EventBusFactory {
  static resolve(name) {
    if (name in implementations) return implementations[name];
    else return implementations.global;
  }
  static get() {
    return new BaseEventBus();
  }
}
